module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("2Tuwe"))).then(() => parcelRequire('hEqeo'));